<template>
    <LinkCss v-for="link in props.links" :key="link" :href="link" @update:on-load-end="setCountLoadEnd($event)" />
</template>
<script lang="ts" setup>
import LinkCss from "@/components/LinkCss.vue"
import { ref } from "vue";
const props = defineProps<{
    links: string[]
    onLoadEnd?: boolean
}>()
const emit = defineEmits<{
    (e: 'update:onLoadEnd', v : boolean) :void
}>()
const countLoadEnd = ref(0)

const setCountLoadEnd = (value: boolean) => {
    if(!value) {
        return
    }
    countLoadEnd.value++
    if (countLoadEnd.value < props.links.length ) {
        return
    }
    emit('update:onLoadEnd', value)
}

</script>